import React from "react";
import {NavLink } from "react-router-dom";

function ProfileCard(props) {
  return (
    <div className="widget-profile widget card-45 mb-30">
      {/* Profile */}
      <div className="author-profile mt-0 text-center text-white d-inline-block pb-4">
        <div className="user-avatar">
          <img src={props.avatarImgSrc} alt="" />
          <span className="user-status">
            <img src={props.statusImgSrc} alt="" className="svg" />
          </span>
        </div>

        <h5 className="user_name text-white">{props.authorName}</h5>
      </div>
      {/* End Profile */}

      <div className="d-flex flex-wrap align-items-center justify-content-center">
        {/* Copy Clipboard */}
        <div className="copy-clipboard-wrap mr-10 mb-4">
          <input
            className="form-control"
            id="get-link"
            type="text"
            value={props.code}
            readOnly
          />

          {/* Copy Button */}
          <NavLink to="#" id="copy-link-btn">
            <img src="/img/icons/copy-icon.svg" alt="" className="svg" />
          </NavLink>
          {/* End Copy Button */}
        </div>
        {/* End Copy Clipboard */}

        {/* Share */}
        <div className="dropdown mr-10 mb-4">
          <button
            className="btn-circle style--two dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <img src="/img/icons/share-grey.svg" alt="" className="svg" />
          </button>
          <ul className="dropdown-menu">
            <li>
              <NavLink
                className="dropdown-item"
                
                to={props.facebookLink}
              >
                <img src="/img/icons/facebook.svg" alt="" /> Share on Facebook
              </NavLink>
            </li>
            <li>
              <NavLink
                className="dropdown-item"
                
                to={props.twitterLink}
              >
                <img src="/img/icons/twitter.svg" alt="" /> Share on Twitter
              </NavLink>
            </li>
            <li>
              <NavLink
                className="dropdown-item"
                
                to={props.instagramLink}
              >
                <img src="/img/icons/instagram.svg" alt="" /> Share on Instagram
              </NavLink>
            </li>
            <li>
              <NavLink
                className="dropdown-item"
                
                to={props.linkedinLink}
              >
                <img src="/img/icons/linkedin.svg" alt="" /> Share on Linkedin
              </NavLink>
            </li>
          </ul>
        </div>
        {/* End Share */}

        <NavLink to="explore.html" className="btn btn-border style--two mr-10 mb-4">
          Follow
        </NavLink>

        {/* Options */}
        <div className="dropdown mb-4">
          <button
            className="btn-circle style--two dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <img src="/img/icons/option-icon.svg" alt="" className="svg" />
          </button>
          <ul className="dropdown-menu">
            <li>
              <NavLink className="dropdown-item"  to="#">
                Report
              </NavLink>
            </li>
          </ul>
        </div>
        {/* End Options */}
      </div>
    </div>
  );
}

export default ProfileCard;
